<div acLabel class="{{ngClass}}">
    <ng-content></ng-content>
</div>
